import { render, staticRenderFns } from "./authRule.vue?vue&type=template&id=05d42d02&scoped=true&"
import script from "./authRule.vue?vue&type=script&lang=js&"
export * from "./authRule.vue?vue&type=script&lang=js&"
import style0 from "./authRule.vue?vue&type=style&index=0&id=05d42d02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d42d02",
  null
  
)

export default component.exports